import { IToast } from '@/typings/global';
import React, { useEffect } from 'react';

interface IToastProps extends IToast {
    destroy: (id: string) => void;
}
function Toast({
    type,
    destroy,
    id,
    content,
    duration = 1000,
    icon = true
}: IToastProps): JSX.Element {
    useEffect(() => {
        if (duration) {
            const timer = setTimeout(() => {
                destroy(id);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [id]);
    return (
        <div
            className={classnames(`toast-item toast-${type}`, {
                icon
            })}
        >
            {icon && <i className={`ic-toast-${type}`} />}
            <p className="toast-title">{content}</p>
        </div>
    );
}
export default Toast;
